export class ApiFout extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function verzoek<T>(method: string, url: string, body?: unknown): Promise<T> {
  const r = await fetch(url, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const tekst = await r.text();
  const data = tekst ? JSON.parse(tekst) : undefined;
  // SPEC §12.3: licentie geblokkeerd of module uit → app laat /api/ik opnieuw ophalen
  if ((r.status === 402 || data?.code === 'MODULE') && url.startsWith('/api/')) window.dispatchEvent(new Event('ep-licentie'));
  if (!r.ok) throw new ApiFout(r.status, data?.fout ?? `Fout ${r.status}`);
  return data as T;
}

export const api = {
  get: <T>(url: string) => verzoek<T>('GET', url),
  post: <T>(url: string, body?: unknown) => verzoek<T>('POST', url, body ?? {}),
  put: <T>(url: string, body: unknown) => verzoek<T>('PUT', url, body),
  patch: <T>(url: string, body: unknown) => verzoek<T>('PATCH', url, body),
  del: <T>(url: string) => verzoek<T>('DELETE', url),
};
